<template>
  <div>
    <section class="mb-5">
      <image-element :src="require('@/assets/Projects/jeon/gif_low.gif')" />
      <h1>
        [올라라 삼성전자, 달려라 삼전개미]
      </h1>
      <p class="desc">
        지난 1월 11일, 삼성전자의 주가는 최고점인 96,000원을 찍은 후 6개월이라는
        꽤 긴 시간 동안 조정을 겪고 있다. 최근 2분기에는 기대 이상의 실적을
        기록했음에도, 여러 가지 이유로 주가는 오히려 하락세를 보여 많은 주주들이
        답답함을 내비치고 있다. [올라라 삼성전자, 달려라 삼전개미]는 이러한
        현상에 반기를 들고 다시금 주가가 크게 오를 것이라는 희망과 주주로서의
        결속감을 전달하고자 하는 포스터이다. 팬데믹 현상과 취업난 등으로 나아갈
        곳 없는 암울한 현실에서, 삼성전자 주가의 상승은 어쩌면 하나의 돌파구가
        될 수 있을지도 모른다. 비록 지금은 긴 조정을 겪고 있을지라도, 기업의
        방향성에 대한 확신을 가지고 기다린다면- 가까운 미래에 10만 전자의 꿈을
        이룰 수 있지 않을까?
      </p>
    </section>

    <section class="mb-5">
      <image-element :src="require('@/assets/Projects/jeon/000.jpg')" />
      <image-element :src="require('@/assets/Projects/jeon/wide.jpg')" />
      <!-- <image-element :src="require('@/assets/Projects/jeon/002.jpg')" />
      <image-element :src="require('@/assets/Projects/jeon/003.jpg')" />
      <image-element :src="require('@/assets/Projects/jeon/004.jpg')" />
      <image-element :src="require('@/assets/Projects/jeon/005.jpg')" /> -->
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
